import React, { useEffect } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { shadow } from "theme/GlobalElements";
import { selectMessage, hideMessage } from "./messageSlice";
import { useLocation } from "react-router-dom";

interface MessageProps {}

const Message: React.FC<MessageProps> = ({}) => {
  const location = useLocation();

  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");
  const dispatch = useDispatch();

  const { showMessage, text, type } = useSelector(selectMessage);

  const closeMessage = () => {
    dispatch(hideMessage());
  };

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 5000);
    }
  }, [showMessage]);
  if (isSitemap || isLogin) return null;

  return (
    <CompareMessageContainer className={`${showMessage ? "active" : ""}`} style={{ backgroundColor: type }}>
      <Title>{text}</Title>
      <MdClose color="white" className="remove-item" size="2em" onClick={closeMessage} />
    </CompareMessageContainer>
  );
};

const CompareMessageContainer = styled.div`
  ${shadow}
  position: fixed;
  bottom: 100px;
  padding: 10px 20px;
  width: 85%;

  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: 0.3s all;
  z-index: 9999;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  display: none;
  &.active {
    opacity: 1;
    display: inline-flex;
  }

  .remove-item {
    padding: 0 20px;
  }

  @media only screen and (${device.tablet}) {
    width: 70vw;
  }

  @media only screen and (${device.laptop}) {
    width: 60vw;
  }

  @media only screen and (${device.laptopL}) {
    width: 40vw;
  }
`;

const Title = styled.p`
  flex: 2;
  color: white;
  font-weight: 600;
  text-align: center;
`;

export default Message;
